import { MovementOrderStrategy, MovementOrderTargetStationStrategy, MovementOrderVehicleStrategy, Vehicle } from './../../movement-orders.model';
import { Component, OnInit, Inject } from '@angular/core';
import { MovementOrderDetails } from '../../movement-orders.model';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { StationGroup } from 'src/tmc-yard/client/model/station-group';
import { StructureSelctionFilter, StructureSelection, StructureSelectionContext, StructureSelectionDialogScope } from 'src/tmc-yard/common/structure-selection/structure-selection.model';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup, Validators } from '@angular/forms';
import { TranslationService } from '@sdbn/common';

@Component({
  selector: 'app-movement-order-strategy-dialog',
  templateUrl: './movement-order-strategy-dialog.component.html',
  styleUrls: ['./movement-order-strategy-dialog.component.scss']
})
export class MovementOrderStrategyDialogComponent implements OnInit {

  vehicleOptionsFormGroup = new FormGroup({});
  vehicleSelectionMode = 'automatically';

  confirmDialogEnabled = true;
  movementOrderDetails: MovementOrderDetails;

  stationGroups: Array<StationGroup>;
  selectedStationGroup: StationGroup = null;
  structureSelectionValid = false;

  selection: StructureSelection;
  structureSelectionContext: StructureSelectionContext;

  selectedVehicleId: number;

  vehicleSelectionRequired = false;
  stationSelectionRequired = false;

  constructor(
    private dialog: MatDialogRef<MovementOrderStrategyDialogComponent>,
    public translationService: TranslationService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.movementOrderDetails = this.data.movementOrderDetails;
    this.vehicleSelectionRequired = this.movementOrderDetails.vehicleStrategy !== MovementOrderVehicleStrategy.FIXED;
    this.stationSelectionRequired = this.movementOrderDetails.targetStationStrategy !== MovementOrderTargetStationStrategy.FIXED;

    this.selection = new StructureSelection();
    this.selection.stationSetId = (this.movementOrderDetails.targetStationSetId);
    this.structureSelectionContext = new StructureSelectionContext(StructureSelectionDialogScope.STATION, this.selection, StructureSelctionFilter.ANY);
    this.structureSelectionContext.setFixedStationSet(this.movementOrderDetails.targetStationSetId);
    this.structureSelectionContext.validation$.subscribe(validation => {
      this.structureSelectionValid = validation;
      this.updateEnabledment();
    });

    this.vehicleOptionsFormGroup.addControl('vehicleSelectionMode', new FormControl(this.vehicleSelectionMode, [Validators.required]))
    this.vehicleOptionsFormGroup.valueChanges.subscribe(
      v => {
        this.vehicleSelectionMode = v.vehicleSelectionMode;
        if (this.vehicleSelectionMode === 'automatically') {
          this.selectedVehicleId = null;
        }
        this.updateEnabledment();
      }
    );
    this.updateEnabledment();
  }

  ngOnInit(): void {
  }

  public confirmDialog() {
    const result: MovementOrderStrategy = {
      targetStationId: this.structureSelectionContext.selection.stationId,
      vehicleId: this.selectedVehicleId
    }
    this.dialog.close(result);
  }

  public selectedVehicleChanged(vehicleId: number) {
    this.selectedVehicleId = vehicleId;
    this.updateEnabledment();
  }

  public cancelDialog() {
    this.dialog.close(null);
  }

  private updateEnabledment() {
    let stationSelectionValid = true;
    if (this.stationSelectionRequired) {
      stationSelectionValid = this.structureSelectionValid && this.structureSelectionContext.selection.stationSetId === this.movementOrderDetails.targetStationSetId
    }

    let vehicleSelectionValid = true;
    if (this.vehicleSelectionRequired && this.vehicleSelectionMode === 'manually') {
      vehicleSelectionValid = this.selectedVehicleId != null;
    }

    this.confirmDialogEnabled = stationSelectionValid && vehicleSelectionValid;
  }
}
